import { Modal } from 'react-bootstrap'
import React from 'react'

export const ModalLoader = ({show,onHide}) => {
  return (
    <div>
      <Modal show={show} onHide={onHide}>
        <Modal.Body>
          <div className="d-flex" style={{zIndex:9999}}>
            <div
              className="spinner-border text-primary"
              role="status"
              
            >
              <span className="sr-only"></span>
            </div>
            <div className="p-1 text-primary">
              Please wait while loading...
            </div>
          </div>
        </Modal.Body>
      </Modal>
    </div>
  )
}
